import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Button, Table, Space, message } from "antd";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import TaxWarrantLiensModel from "./TaxWarrantLiensModel";
import {
  createTwlRecords,
  deleteTwlRecords,
  getTwlRecords,
} from "../../../../../services/adminForm.services";
import { useQuery } from "../../../../../helpers/utility";

const TaxWarrantLiens = ({ disable }) => {
  const query = useQuery();
  const applicationId = query.get("id");
  const [visible, setVisible] = useState(false);
  const [editTable, setEditTable] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [tableLoading, setTableLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const refreshPage = () => {
    setRefresh((prevValue) => !prevValue);
  };

  useEffect(() => {
    setTableLoading(true);
    getTwlRecords(applicationId)
      .then((res) => {
        setTableData(res.data);
        setTableLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setTableLoading(false);
      });
  }, [refresh]);

  const columns = [
    {
      title: "File Type",
      dataIndex: "file_type",
      key: "file_type",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Filing No",
      dataIndex: "filing_no",
      key: "filing_no",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Filing Date",
      dataIndex: "filing_date",
      key: "filing_date",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      ellipsis: true,
      width: 100,
    },
    {
      title: "County",
      dataIndex: "county",
      key: "county",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Release Date",
      dataIndex: "release_date",
      key: "release_date",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Action",
      key: "action",
      width: 160,
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ formData: record, status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  const openModal = (data) => {
    setVisible(true);
    setEditTable(data);
  };

  const removeColumn = (id) => {
    deleteTwlRecords(id)
      .then((res) => {
        message.success("Deleted");
        refreshPage();
      })
      .catch((err) => {
        message.error("Failed to remove Twl Records");
        console.log(err);
      });
  };

  return (
    <Fragment>
      <Row style={disable ? { pointerEvents: "none" } : {}}>
        <Col>
          <Button
            onClick={() => openModal({ status: "create" })}
            type="secondary"
            style={{
              marginBottom: 16,
            }}
          >
            Add Details
          </Button>
        </Col>
        <Col span={24}>
          <Table
            size="small"
            columns={columns}
            pagination={false}
            dataSource={tableData}
            loading={tableLoading}
            scroll={{ x: 800 }}
          />
        </Col>
      </Row>
      {visible && (
        <TaxWarrantLiensModel
          setVisible={setVisible}
          title="Tax Warrant Liens"
          editTable={editTable}
          refresh={refreshPage}
        />
      )}
    </Fragment>
  );
};

export default TaxWarrantLiens;
